"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonContainer = SkeletonContainer;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "children", "testId", "ariaLabel", "width", "height", "preserveAspectRatio", "clipId", "gradientId", "animateId", "backgroundColor", "backgroundOpacity", "animate", "speed", "foregroundColor", "foregroundOpacity", "svgWidth", "svgHeight"];
var styles = {
  "SkeletonContainer": "SkeletonContainer__SkeletonContainer___23jiu"
};
var idCounter = 0;

function SkeletonContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-skeleton-form' : _ref$testId,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'Loading component...' : _ref$ariaLabel,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$clipId = _ref.clipId,
      clipId = _ref$clipId === void 0 ? "cf-ui-skeleton-clip-".concat(idCounter++) : _ref$clipId,
      _ref$gradientId = _ref.gradientId,
      gradientId = _ref$gradientId === void 0 ? "cf-ui-skeleton-clip-gradient-".concat(idCounter++) : _ref$gradientId,
      _ref$animateId = _ref.animateId,
      animateId = _ref$animateId === void 0 ? "animation-".concat(idCounter++) : _ref$animateId,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '#e5ebed' : _ref$backgroundColor,
      _ref$backgroundOpacit = _ref.backgroundOpacity,
      backgroundOpacity = _ref$backgroundOpacit === void 0 ? 1 : _ref$backgroundOpacit,
      _ref$animate = _ref.animate,
      animate = _ref$animate === void 0 ? true : _ref$animate,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 2 : _ref$speed,
      _ref$foregroundColor = _ref.foregroundColor,
      foregroundColor = _ref$foregroundColor === void 0 ? '#f7f9fa' : _ref$foregroundColor,
      _ref$foregroundOpacit = _ref.foregroundOpacity,
      foregroundOpacity = _ref$foregroundOpacit === void 0 ? 1 : _ref$foregroundOpacit,
      _ref$svgWidth = _ref.svgWidth,
      svgWidth = _ref$svgWidth === void 0 ? '100%' : _ref$svgWidth,
      _ref$svgHeight = _ref.svgHeight,
      svgHeight = _ref$svgHeight === void 0 ? '100%' : _ref$svgHeight,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles['SkeletonContainer'], className);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    role: "img",
    className: classNames,
    "aria-label": ariaLabel,
    preserveAspectRatio: preserveAspectRatio,
    width: svgWidth,
    height: svgHeight,
    "data-test-id": testId
  }, otherProps), ariaLabel ? /*#__PURE__*/_react["default"].createElement("title", null, ariaLabel) : null, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: width,
    height: height,
    clipPath: "url(#".concat(clipId, ")"),
    style: {
      fill: "url(#".concat(gradientId, ")")
    }
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: clipId
  }, children), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: gradientId
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: backgroundColor,
    stopOpacity: backgroundOpacity
  }, animate && /*#__PURE__*/_react["default"].createElement("animate", {
    id: animateId,
    attributeName: "stop-color",
    values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
    dur: "".concat(speed, "s"),
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "50%",
    stopColor: foregroundColor,
    stopOpacity: foregroundOpacity
  }, animate && /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stop-color",
    values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
    begin: "".concat(animateId, ".begin+0.25s"),
    dur: "".concat(speed, "s"),
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: backgroundColor,
    stopOpacity: backgroundOpacity
  }, animate && /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "stop-color",
    begin: "".concat(animateId, ".begin+0.5s"),
    values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
    dur: "".concat(speed, "s"),
    repeatCount: "indefinite"
  })))));
}